/* eslint-disable max-len */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable id-blacklist */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable curly */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/quotes */
import { Component, OnInit } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular';

import { GlobalVariable } from '../global';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
interface PaymentData {
  creditcardno: String;
  expiryMonth: String;
  expiryYear: String;
  CVC: String;
  cardinfo: Boolean;
}
@Component({
  selector: 'app-payments',
  templateUrl: './payments.page.html',
  styleUrls: ['./payments.page.scss'],
})
export class PaymentsPage implements OnInit {
  isActive = true;
  isChecked = false;
  cardName;
  cardNumber;
  CVC;
  paymentMethods = [];
  cardinfo: any = {
    number: '',
    expMonth: '',
    expYear: '',
    cvc: ''
  }

  submitAttempt: boolean = false;
  payData: PaymentData;
  yearArray = []
  PaymentForm: FormGroup;
  currentYear = new Date();


  isMobile = false;

  constructor(
    private platform: Platform,
    private alertController: AlertController,
    private globals: GlobalVariable,
    public fb: FormBuilder,
  ) {
    if (this.platform.is('mobile')) {
      this.isMobile = true;
    } else if (this.platform.is('desktop')) {
      this.isMobile = false;
    }
    let years = this.currentYear.getFullYear() - 1;
    console.log(years);
    let i;
    for (i = 0; i < 10; i++) {
      years = years + 1;
      this.yearArray.push(years);
    }
    console.log(this.yearArray);
    this.payData = {} as PaymentData;
    console.log(this.globals.paymentPageData)


    this.PaymentForm = this.fb.group({
      creditcardno: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(15),
          Validators.maxLength(16),
          this.validateCardNumber,
          Validators.pattern('[0-9]*'),
        ])
      ),
      expiryMonth: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      expiryYear: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      CVC: new FormControl(
        '',
        Validators.compose([Validators.required,])
      ),
      cardinfo: new FormControl(
        '',
      ),
    });
    console.log(this.payData);
  }

  ngOnInit() { }

  ionViewWillEnter() {

    this.getSavedCards();
  }
  validateCardNumber(control: AbstractControl): ValidationErrors | null {
    const cardNumberPattern = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/;

    const isValid = cardNumberPattern.test(control.value);
    return isValid ? null : { invalidCardNumber: true };
  }
  getSavedCards() {
    let tempArray = []
    let response = localStorage.getItem('paymentmethods')
    tempArray = JSON.parse(response)
    console.log('from local storage', tempArray)
    if (tempArray != null) {
      this.paymentMethods = tempArray;
    }
  }
  switchToCustomize() {
    if (this.isActive == false) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }
  selectPayment(payment) {
    this.globals.presentToast('swipe left to delete', 'middle')

  }
  get errorControl() {
    return this.PaymentForm.controls;
  }
  async addNewMethod() {
    if (!this.PaymentForm.valid) {
      this.submitAttempt = true;
      this.globals.presentToast(' Some values were not given or were incorrect, please fill them');
    } else {

      if (this.paymentMethods.length < 4) {
        this.paymentMethods.push(this.PaymentForm.value);
        localStorage.setItem('paymentmethods', JSON.stringify(this.paymentMethods))
        // this.storage.set('paymentMethods', this.paymentMethods);
        console.log(this.paymentMethods);
        this.isActive = true;
        this.globals.presentToast("Card info saved.")
        this.getSavedCards();


      } else {
        console.log('cant add');
        this.globals.alertSimple(
          'Payment Medhods Limit',
          "You've reached the limit. try removing old methods from profile page",
          'OK'
        );

      }
    }
  }
  removePayment(p) {
    this.globals.removeItemFromArray(this.paymentMethods, p);
    console.log(this.paymentMethods);
    localStorage.setItem('paymentmethods', JSON.stringify(this.paymentMethods))
  }

  maskNumber(cardNumber: string): string {
    if (cardNumber.length <= 8) return cardNumber;
    const visibleStart = cardNumber.slice(0, 4);
    const visibleEnd = cardNumber.slice(-4);
    const maskedPart = '*'.repeat(cardNumber.length - 8);
    return `${visibleStart}${maskedPart}${visibleEnd}`;
  }


}
